/** Existing onboarding policy: all assigned tasks are equally weighted. */
export function onboardingProgress(completed: number, total: number): number {
  return total > 0 ? Math.round(Math.max(0, Math.min(completed, total)) / total * 100) : 0;
}

export function onboardingTaskProgress(tasks: ReadonlyArray<{ status: string }>): number {
  return onboardingProgress(tasks.filter(task => task.status === "completed").length, tasks.length);
}
